/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    CreateNotificationPreferenceRequest,
    NotificationPreferenceDto,
    UpdateNotificationPreferenceRequest,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    CreateNotificationPreferenceRequestFromJSON,
    CreateNotificationPreferenceRequestToJSON,
    NotificationPreferenceDtoFromJSON,
    NotificationPreferenceDtoToJSON,
    UpdateNotificationPreferenceRequestFromJSON,
    UpdateNotificationPreferenceRequestToJSON,
} from "../models/index";

export interface CreateNotificationPreferenceOperationRequest {
    body?: CreateNotificationPreferenceRequest;
}

export interface DeleteNotificationPreferenceRequest {
    notificationPreferenceId: number;
}

export interface GetNotificationPreferenceRequest {
    notificationPreferenceId: number;
}

export interface UpdateNotificationPreferenceOperationRequest {
    notificationPreferenceId: number;
    body?: UpdateNotificationPreferenceRequest;
}

/**
 *
 */
export class NotificationPreferencesHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Create a new notification preference for a user.
     */
    async createNotificationPreferenceRaw(
        requestParameters: CreateNotificationPreferenceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/notification-preferences`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreateNotificationPreferenceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a new notification preference for a user.
     */
    async createNotificationPreference(
        requestParameters: CreateNotificationPreferenceOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createNotificationPreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete a notification preference.
     */
    async deleteNotificationPreferenceRaw(
        requestParameters: DeleteNotificationPreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["notificationPreferenceId"] == null) {
            throw new runtime.RequiredError(
                "notificationPreferenceId",
                'Required parameter "notificationPreferenceId" was null or undefined when calling deleteNotificationPreference().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/notification-preferences/{notificationPreferenceId}`.replace(
                    `{${"notificationPreferenceId"}}`,
                    encodeURIComponent(
                        String(requestParameters["notificationPreferenceId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete a notification preference.
     */
    async deleteNotificationPreference(
        requestParameters: DeleteNotificationPreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteNotificationPreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a notification preference by ID.
     */
    async getNotificationPreferenceRaw(
        requestParameters: GetNotificationPreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<NotificationPreferenceDto>> {
        if (requestParameters["notificationPreferenceId"] == null) {
            throw new runtime.RequiredError(
                "notificationPreferenceId",
                'Required parameter "notificationPreferenceId" was null or undefined when calling getNotificationPreference().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/notification-preferences/{notificationPreferenceId}`.replace(
                    `{${"notificationPreferenceId"}}`,
                    encodeURIComponent(
                        String(requestParameters["notificationPreferenceId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            NotificationPreferenceDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get a notification preference by ID.
     */
    async getNotificationPreference(
        requestParameters: GetNotificationPreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<NotificationPreferenceDto> {
        const response = await this.getNotificationPreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint that lists notification preferences visible for the current IlluminateUser.
     */
    async notificationPreferenceODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<NotificationPreferenceDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/odata/notification-preferences`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(NotificationPreferenceDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists notification preferences visible for the current IlluminateUser.
     */
    async notificationPreferenceOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<NotificationPreferenceDto>> {
        const response =
            await this.notificationPreferenceODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an existing notification preference.
     */
    async updateNotificationPreferenceRaw(
        requestParameters: UpdateNotificationPreferenceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["notificationPreferenceId"] == null) {
            throw new runtime.RequiredError(
                "notificationPreferenceId",
                'Required parameter "notificationPreferenceId" was null or undefined when calling updateNotificationPreference().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/notification-preferences/{notificationPreferenceId}`.replace(
                    `{${"notificationPreferenceId"}}`,
                    encodeURIComponent(
                        String(requestParameters["notificationPreferenceId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateNotificationPreferenceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update an existing notification preference.
     */
    async updateNotificationPreference(
        requestParameters: UpdateNotificationPreferenceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateNotificationPreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
